import React from 'react'
import { useState } from 'react';
import { auth, provider } from './firebase-config';
import { signInWithPopup, getAuth, createUserWithEmailAndPassword, sendEmailVerification, signInWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import SignUp from './SignUp';


function Login({ setIsAuth }) {


    //Sign Up
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")


    //Sign In EMAIL

    const signIn = () => {

        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                alert("user has signed in successfully")
                localStorage.setItem("isAuth", true);
                localStorage.setItem("user", auth.currentUser.displayName);
                localStorage.setItem("email", auth.currentUser.email);

                setIsAuth(true);
                navigate("/");
                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert("Please check your email or password")
            });
    }

    //Sign In Google
    let navigate = useNavigate();
    const signInWithGoogle = () => {
        signInWithPopup(auth, provider).then((result) => {
            localStorage.setItem("isAuth", true);
            localStorage.setItem("user", auth.currentUser.displayName);
            localStorage.setItem("email", auth.currentUser.email);

            setIsAuth(true);
            navigate("/");
        })
    }

    return (
        <div className="container-fluid login-background">
            <h1 className='hide'> space</h1>
            <div className='center'>
               <div className='row'>
               <div className='login-info col-sm'>
                    <h1>Login to Access More Content</h1>
                    <div className='email'>
                        <h5>Email:</h5>
                        <input id='email' type={"email"} placeholder="please enter your email" onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <h5>Password:</h5>
                    <div className='password'>
                        <input id='password' type={"password"} placeholder="please enter your password" onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div className='login-buttons'>
                        <button onClick={signIn}>Sign In</button>

                    </div>


                    <p>Or</p>

                    <button className="login-with-google-btn" onClick={signInWithGoogle}>Sign in with Google</button>
                    <p>Don't have an account?<SignUp /></p>
                    <p>Create your own reviews</p>
                    <p>Give Games Custom Ratings</p>
                    <p>Affect the Community Score</p>
                </div>
               </div>
            </div>
        </div>
    )
}

export default Login
